import macrotrends from './macrotrends'
import megatrends from './megatrends'

export default {
    macrotrends,
    megatrends,

    tabs: {
        microtrends: 'Micro-trends',
        macrotrends: 'Macro-trends',
        megatrends: 'Mega-trends'
    },

    pageTitle: 'TREND FINDER - OVERVIEW',

    addButton: {
        tooltip: {
            disabled: 'No micro-trends have been selected',
            addToWorkspace: 'Add to work spaces',
            addToWorkspaceOrInnovationfield: 'Add to work spaces or innovation fields'
        }
    }
}
